import CardMenu from './CardMenu';
export {type IAction} from './shared';
export default CardMenu;
